import CreatePropertyInnerFormElements from "./CreatePropertyInnerFormElementsContainer";
import CreatePropertyModalContainer from "./CreatePropertyModalContainer";

export default CreatePropertyModalContainer;
export * from "./createProperty.config";
export { CreatePropertyInnerFormElements };
